/**
 * @generated SignedSource<<1eb8a5f3ebb0569f706948ccafd1ef42>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueViewJpdIdeas_IdeasDiscoveryCardEligibilityWrapper_issueViewRelayFragment$data = {
  readonly canLinkIssues: boolean | null | undefined;
  readonly issueTypeField: {
    readonly issueType: {
      readonly hierarchy: {
        readonly level: number | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly name: string;
  } | null | undefined;
  readonly statusCategory: {
    readonly statusCategoryId: string;
  } | null | undefined;
  readonly " $fragmentType": "ui_issueViewJpdIdeas_IdeasDiscoveryCardEligibilityWrapper_issueViewRelayFragment";
};
export type ui_issueViewJpdIdeas_IdeasDiscoveryCardEligibilityWrapper_issueViewRelayFragment$key = {
  readonly " $data"?: ui_issueViewJpdIdeas_IdeasDiscoveryCardEligibilityWrapper_issueViewRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewJpdIdeas_IdeasDiscoveryCardEligibilityWrapper_issueViewRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_issueViewJpdIdeas_IdeasDiscoveryCardEligibilityWrapper_issueViewRelayFragment",
  "selections": [
    {
      "alias": "canLinkIssues",
      "args": [
        {
          "kind": "Literal",
          "name": "permission",
          "value": "LINK_ISSUES"
        }
      ],
      "kind": "ScalarField",
      "name": "hasProjectPermission",
      "storageKey": "hasProjectPermission(permission:\"LINK_ISSUES\")"
    },
    {
      "concreteType": "JiraStatusCategory",
      "kind": "LinkedField",
      "name": "statusCategory",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "statusCategoryId"
          },
          "action": "LOG",
          "path": "statusCategory.statusCategoryId"
        }
      ]
    },
    {
      "concreteType": "JiraIssueTypeField",
      "kind": "LinkedField",
      "name": "issueTypeField",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "name"
          },
          "action": "LOG",
          "path": "issueTypeField.name"
        },
        {
          "concreteType": "JiraIssueType",
          "kind": "LinkedField",
          "name": "issueType",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueTypeHierarchyLevel",
              "kind": "LinkedField",
              "name": "hierarchy",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "level"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "e06279682aee2498332184b9d51aa663";

export default node;
